import api from "../../service/api";
import ConfigureInfo from "@/connect/configureInfo";

export default {
  namespaced: true,
  state: () => ({
    queryTradesData: {},
    tradesloading: true,
  }),
  mutations: {
    SET_TRADES_LOADING(state, data) {
      state.tradesloading = data;
    },
    SET_QUERY_TRADES_DATA(state, opt) {
      state.queryTradesData = opt;
    },

    UPDATE_TRADES_DATA(state, opt) {
      opt.trades.forEach((ele) => {
        // console.log("ele", opt.blockTime, ele);
        ele.createAt = opt.blockTime;
        state.queryTradesData.trades.unshift(ele);

        if (state.queryTradesData.trades.length > 100) {
          state.queryTradesData.trades.pop();
        }
      });
    },
    UP_BLOCK_HEIGHT(state, val) {
      state.queryTradesData.blockHeight = val;
    },
  },
  actions: {
    async getList({ commit, rootState }, opt) {
      commit("SET_TRADES_LOADING", true);

      const queryTradesData = await api["queryTrades"]({
        pair: opt.pair,
      });

      rootState.ws.websocketsend({
        type: "subscribe",
        channel: "trades",
        id: rootState.tradingPair.queryPairInfo.pair,
        last_height: queryTradesData.blockHeight,
        chainId: ConfigureInfo.Marginx.chainId,
      });

      commit("SET_QUERY_TRADES_DATA", queryTradesData);

      commit("SET_TRADES_LOADING", false);
    },
    setTrades({ commit }, data) {
      // data.forEach((value) => {
      if (data) {
        commit("UPDATE_TRADES_DATA", {
          trades: data.trades,
          blockTime: data.blockTime,
        });

        if (data["blockHeight"]) {
          commit("UP_BLOCK_HEIGHT", data.blockHeight);
        }
      }
      // });
    },
  },
  getters: {},
};
